export const getRequestHeaders = async (
  credentials = true,
): Promise<RequestInit> => {
  const headers = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json; charset=UTF-8',
  }

  if (credentials) {
    const response = await fetch('/api/v2/csrf-token')
    const { token } = await response.json()

    return {
      credentials: credentials ? 'include' : 'omit',
      headers: {
        ...headers,
        'X-CSRF-Token': token,
      },
    }
  }

  return {
    credentials: credentials ? 'include' : 'omit',
    headers,
  }
}
